import React, {PureComponent} from "react";

class RadioField extends PureComponent {
    render() {
        const {input, children, meta: {touched, error, warning}, disabled, className} = this.props;

        return (
            <label className={className || 'form-radio'}>
                <input
                    {...input}
                    type="radio"
                    disabled={disabled}
                    ref={radioInput => this.radioInput = radioInput}
                />
                <span
                    className="form-radio__checkmark"
                    onClick={() => this.radioInput.checked}
                />
                {children}
                {touched && (
                    (error && <div className="text-danger scroll-to-error">{error}</div>) ||
                    (warning && <div className="text-warning">{warning}</div>)
                )}
            </label>
        )
    }
}

export default RadioField;